export function isLandscapeViewport() {
  if (typeof window === "undefined") {
    return false;
  }

  const screenOrientation = window.screen?.orientation?.type;
  if (screenOrientation) {
    return screenOrientation.startsWith("landscape");
  }

  if (typeof window.orientation === "number") {
    return Math.abs(window.orientation) === 90;
  }

  if (window.screen?.width && window.screen?.height) {
    return window.screen.width > window.screen.height;
  }

  return (
    window.matchMedia("(orientation: landscape)").matches &&
    window.innerWidth > window.innerHeight
  );
}

export function getViewportScreenMode() {
  return isLandscapeViewport() ? "landscap" : "portrait";
}

export function subscribeViewportOrientation(onChange) {
  if (typeof window === "undefined") {
    return () => {};
  }

  const sync = () => onChange(getViewportScreenMode());

  window.addEventListener("orientationchange", sync);
  window.addEventListener("resize", sync);

  if (window.screen?.orientation?.addEventListener) {
    window.screen.orientation.addEventListener("change", sync);
  }

  return () => {
    window.removeEventListener("orientationchange", sync);
    window.removeEventListener("resize", sync);

    if (window.screen?.orientation?.removeEventListener) {
      window.screen.orientation.removeEventListener("change", sync);
    }
  };
}
